// extracted by mini-css-extract-plugin
module.exports = {"container":"headerAndBody_container__BN_ut","eyebrow":"headerAndBody_eyebrow__7dT5W","headline":"headerAndBody_headline__qDX_7","copy":"headerAndBody_copy__di7oO"};